module.exports = __webpack_public_path__ + "static/media/ether.76c5af0a.png";